import { PropsPermissao } from "../../interfaces/perfil"
import { useEffect, useState } from "react"
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import { descriptografarDado } from "../../helpers"

const useUsuarioPermissoes = () => {
    const navigate = useNavigate()
    const [permissoes, setPermissoes] = useState<string[]>([])

    useEffect(() => {
        const obterPermissoes = () => {
            try {
                const permissoesCript = localStorage.getItem('permissao')
                const token = document.cookie.split("; ").find((token) => token.startsWith("authGesttor"))

                if (!token || !permissoesCript) {
                    navigate('/auth')
                    return
                }

                const permissoesDescript = descriptografarDado(permissoesCript)

                const permissoesArray = JSON.parse(permissoesDescript)

                setPermissoes(permissoesArray)
            } catch (err) {
                console.error(err)
                toast.error("Erro ao obter permissões do usuário.")
            }
        }

        obterPermissoes()
    }, [navigate])

    return permissoes
}

const Permissao = ({ permissoes: permissoesPermitidas, children }: PropsPermissao) => {

    const usuarioPermissoes = useUsuarioPermissoes()

    const temPermissao = permissoesPermitidas.some(p => usuarioPermissoes.includes(p))

    if (temPermissao) {
        return <>{children}</>
    }

    return null
}

export default Permissao